import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularSection() {
  const popularComics = comics
    .filter((c) => c.popular)
    .sort((a, b) => b.rating - a.rating);

  const topRatedComics = comics
    .filter((c) => !c.popular)
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 5);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="popular-heading">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 id="popular-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500">千万读者共同选择的高分韩漫</p>
              </div>
              <Link
                to="/category/love"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
              {popularComics.slice(0, 8).map((comic, index) => (
                <div key={comic.id} className="relative">
                  <Link to={`/comic/${comic.id}`} className="group block" data-product-shop="">
                    <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100">
                      <img
                        src={comic.cover}
                        alt={`${comic.title} - 热门韩国漫画`}
                        title={`${comic.title} - 韩漫在线免费阅读`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute top-2 left-2 bg-primary-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap">
                        TOP {index + 1}
                      </div>
                      <div className="absolute top-2 right-2 bg-black/70 text-accent-400 text-[11px] font-medium px-1.5 py-0.5 rounded flex items-center gap-0.5 whitespace-nowrap">
                        <i className="ri-star-fill text-[9px]"></i>
                        {comic.rating}
                      </div>
                    </div>
                    <h3 className="text-[15px] font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                      {comic.title}
                    </h3>
                    <div className="flex items-center gap-2 text-xs text-foreground-500">
                      <span>{comic.views}</span>
                      <span className="text-foreground-300">·</span>
                      <span>{comic.chapters}话</span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[280px] flex-shrink-0">
            <div className="bg-background-100 rounded-2xl p-5 lg:sticky lg:top-24">
              <div className="flex items-center gap-2 mb-5">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-fire-line text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900">排行榜</h3>
              </div>
              <div className="space-y-1">
                {topRatedComics.map((comic, index) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.id}`}
                    className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-background-200/70 transition-colors duration-200 group"
                  >
                    <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                      index === 0 ? 'bg-accent-500 text-white' :
                      index === 1 ? 'bg-secondary-400 text-white' :
                      index === 2 ? 'bg-secondary-500 text-white' :
                      'bg-background-200 text-foreground-500'
                    }`}>
                      {index + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                        {comic.title}
                      </p>
                      <div className="flex items-center gap-1.5 mt-0.5">
                        <span className="text-[11px] text-foreground-500">{comic.categoryName}</span>
                        <span className="text-foreground-300 text-[10px]">·</span>
                        <span className="text-[11px] text-accent-500 flex items-center gap-0.5">
                          <i className="ri-star-fill text-[9px]"></i>
                          {comic.rating}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}